<template>
  <div>
    <!-- 表示切替: 月カレンダー=俯瞰 / 週シフト=シフト管理 / 日別予約=予約ボード+出勤確認 / 予約一覧=期間検索 -->
    <div class="d-flex align-center mb-3">
      <v-btn-toggle
        v-model="view"
        mandatory
        dense
      >
        <v-btn
          value="month"
          :ripple="false"
        >
          月カレンダー
        </v-btn>
        <v-btn
          value="week"
          :ripple="false"
        >
          週シフト
        </v-btn>
        <v-btn
          value="day"
          :ripple="false"
        >
          日別予約
        </v-btn>
        <v-btn
          value="list"
          :ripple="false"
        >
          予約一覧
        </v-btn>
      </v-btn-toggle>
    </div>

    <shift-month-calendar
      v-if="view === 'month'"
      :key="`month-${refreshKey}`"
      @open-day="openDay"
    />
    <shift-week-board
      v-else-if="view === 'week'"
      :key="`week-${refreshKey}`"
      @open-day="openDay"
    />
    <shift-day-view
      v-else-if="view === 'day'"
      :date="selectedDate"
      @change-date="onChangeDate"
      @open-week="view = 'week'"
      @changed="refreshKey += 1"
    />
    <reservation-list v-else />
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import useCurrentData from '@/views/composable/useCurrentData'
import { getBusinessTodayStr } from '@/views/waiter/floorUtils'
import ShiftMonthCalendar from '@/views/waiter/settings/ShiftMonthCalendar.vue'
import ShiftWeekBoard from '@/views/waiter/settings/ShiftWeekBoard.vue'
import ShiftDayView from '@/views/waiter/settings/ShiftDayView.vue'
import ReservationList from '@/views/waiter/reservations/ReservationList.vue'

const VIEWS = ['month', 'week', 'day', 'list']

export default {
  components: {
    ShiftMonthCalendar,
    ShiftWeekBoard,
    ShiftDayView,
    ReservationList,
  },
  setup(_, { root }) {
    const { currentClub } = useCurrentData()

    // ファーストビューは「当営業日の日別予約」。深夜帯（開店前）は前日の暦日が営業日になる
    const businessTodayStr = getBusinessTodayStr(new Date(), currentClub.value?.openAt)

    // 初期状態はクエリから復元（旧 ?tab=reservations は予約一覧へ互換マップ）
    const { query } = root.$route
    const initialView = (() => {
      if (VIEWS.includes(query.view)) return query.view
      if (query.tab === 'reservations') return 'list'

      return 'day'
    })()

    const view = ref(initialView)
    const selectedDate = ref(/^\d{4}-\d{2}-\d{2}$/.test(query.date || '') ? query.date : businessTodayStr)

    // 他ビューでの変更（週まとめ登録等）後に月/週を開き直したとき再取得させる
    const refreshKey = ref(0)

    const syncQuery = () => {
      const next = { ...root.$route.query, view: view.value }
      if (view.value === 'day') next.date = selectedDate.value
      else delete next.date
      delete next.tab
      if (JSON.stringify(next) === JSON.stringify(root.$route.query)) return
      root.$router.replace({ query: next }).catch(() => {})
    }

    watch([view, selectedDate], syncQuery, { immediate: true })

    // 予約一覧の行タップ等、クエリ経由の遷移（リダイレクト含む）にも追従する
    watch(() => root.$route.query, nextQuery => {
      let nextView = null
      if (VIEWS.includes(nextQuery.view)) nextView = nextQuery.view
      else if (nextQuery.tab === 'reservations') nextView = 'list'
      if (nextQuery.date && /^\d{4}-\d{2}-\d{2}$/.test(nextQuery.date) && nextQuery.date !== selectedDate.value) {
        selectedDate.value = nextQuery.date
      }
      if (nextView && nextView !== view.value) view.value = nextView
    })

    const openDay = dateStr => {
      selectedDate.value = dateStr
      view.value = 'day'
    }

    const onChangeDate = dateStr => {
      selectedDate.value = dateStr
    }

    return {
      view,
      selectedDate,
      refreshKey,
      openDay,
      onChangeDate,
    }
  },
}
</script>
